function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.092 20.2565C18.047 17.3759 17.1496 14.7567 15.5541 12.8603C13.9678 10.9755 11.818 9.9375 9.5 9.9375C7.18203 9.9375 5.03223 10.9755 3.44595 12.8603C1.8519 14.7547 0.955078 17.3703 0.908203 20.2473C1.80957 20.6988 5.53955 22.4375 9.5 22.4375C13.7826 22.4375 17.2561 20.709 18.092 20.2565Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 9.15625C11.8731 9.15625 13.7969 7.23247 13.7969 4.85938C13.7969 2.48628 11.8731 0.5625 9.5 0.5625C7.1269 0.5625 5.20312 2.48628 5.20312 4.85938C5.20312 7.23247 7.1269 9.15625 9.5 9.15625Z",
  fill: "white"
});

var SvgProfileIcon = function SvgProfileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-icon.0036bf10.svg";
export { ForwardRef as ReactComponent };